module.exports = __webpack_public_path__ + "img/Logo.edf6d080.png";